import React, { useCallback } from "react";
import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { requestPermission } from "./GlobalNotificationDispatcher";
import * as userActions from "@profile/actions/userActions";

const isStandaloneMode = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true ||
    document.referrer.includes("android-app://")
  );
};

const isIOSDevice = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined")
    return false;
  return (
    ["iPad", "iPhone", "iPod"].includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

const NotificationButton = ({ className }) => {
  const dispatch = useDispatch();
  const notificationsEnabled = useSelector(
    (state) => state.userInfo?.notifications ?? false,
  );

  const handleClick = useCallback(() => {
    if (isIOSDevice() && !isStandaloneMode() && !("Notification" in window)) {
      alert(
        "To enable brewing alerts on iOS:\n\n1. Tap the Share button in Safari (square with arrow up)\n2. Select 'Add to Home Screen'\n3. Open MiniBrew from your Home Screen to enable notifications.",
      );
      return;
    }

    if (notificationsEnabled) {
      if (window.OneSignal?.User?.PushSubscription) {
        window.OneSignal.User.PushSubscription.optOut().catch((err) => {
          console.warn("OneSignal optOut failed:", err);
        });
      }
      dispatch(userActions.setNotificationPermission(false));
    } else {
      requestPermission();
    }
  }, [notificationsEnabled, dispatch]);

  const iconStyle = { fontSize: "18px", fontWeight: 800 };
  const buttonStyle = {
    borderRadius: 25,
    padding: "4px 10px",
    marginLeft: 20,
    marginTop: 20,
    ...(notificationsEnabled ? { backgroundColor: "#fdcc00" } : {}),
  };

  return (
    <Button className={className} style={buttonStyle} onClick={handleClick}>
      <i style={iconStyle} className="ion-ios-bell-outline" />
    </Button>
  );
};

export default NotificationButton;
